import React, { useEffect, useRef, useState } from "react";

const YOUTUBE_VIDEO_ID = "ShZ978fBl6Y";

interface MusicPlayerProps {
  title?: string;
}

export function MusicPlayer({
  title = "Calum Scott - You Are The Reason (Official Video)",
}: MusicPlayerProps) {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);

  const sendPlayerCommand = (func: "playVideo" | "pauseVideo") => {
    iframeRef.current?.contentWindow?.postMessage(
      JSON.stringify({
        event: "command",
        func,
        args: [],
      }),
      "https://www.youtube.com",
    );
  };

  useEffect(() => {
    const resumeOnFirstInteraction = () => {
      sendPlayerCommand("playVideo");
      setIsPlaying(true);
      setHasStarted(true);
      window.removeEventListener("pointerdown", resumeOnFirstInteraction);
      window.removeEventListener("keydown", resumeOnFirstInteraction);
      window.removeEventListener("touchstart", resumeOnFirstInteraction);
    };

    window.addEventListener("pointerdown", resumeOnFirstInteraction, {
      passive: true,
    });
    window.addEventListener("keydown", resumeOnFirstInteraction);
    window.addEventListener("touchstart", resumeOnFirstInteraction, {
      passive: true,
    });

    return () => {
      window.removeEventListener("pointerdown", resumeOnFirstInteraction);
      window.removeEventListener("keydown", resumeOnFirstInteraction);
      window.removeEventListener("touchstart", resumeOnFirstInteraction);
    };
  }, []);

  const togglePlayback = () => {
    if (isPlaying) {
      sendPlayerCommand("pauseVideo");
    } else {
      sendPlayerCommand("playVideo");
      setHasStarted(true);
    }

    setIsPlaying((current) => !current);
  };

  return (
    <>
      <div className="wedding-music-player" aria-hidden="true">
        <iframe
          ref={iframeRef}
          title={title}
          src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&loop=1&playlist=${YOUTUBE_VIDEO_ID}&controls=0&disablekb=1&enablejsapi=1&playsinline=1&rel=0`}
          allow="autoplay; encrypted-media"
          className="wedding-music-player__iframe"
        />
      </div>

      <button
        type="button"
        className={`wedding-music-toggle${
          hasStarted ? "" : " wedding-music-toggle--attention"
        }`}
        onClick={togglePlayback}
        aria-label={isPlaying ? "Pause background music" : "Play background music"}
        title={isPlaying ? "Pause background music" : "Play background music"}
      >
        <span
          className={`wedding-music-toggle__icon${
            isPlaying ? "" : " wedding-music-toggle__icon--muted"
          }`}
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 24 24"
            className="wedding-music-toggle__svg"
            focusable="false"
          >
            <path
              d="M4 10h4.2l5.2-4.3v12.6L8.2 14H4z"
              fill="currentColor"
            />
            <path
              d="M16.2 8.2a5.1 5.1 0 0 1 0 7.6"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M18.8 5.7a8.6 8.6 0 0 1 0 12.6"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
          {!isPlaying ? (
            <span className="wedding-music-toggle__slash" />
          ) : null}
        </span>
      </button>
    </>
  );
}
